export const UiKit = [
  {
    name: 'uikit.index',
    path: '/dev/uikit',
    component: () => import('@/pages/UiKit/UiKit'),
    meta: {
      dev: true
    }
  },
  {
    name: 'uikit.components',
    path: '/dev/uikit/components',
    component: () => import('@/pages/UiKit/ComponentsPage.vue'),
    meta: {
      dev: true
    }
  },
  {
    name: 'uikit.header',
    path: '/dev/uikit/header',
    component: () => import('@/pages/UiKit/HeaderPage.vue'),
    meta: {
      dev: true
    }
  },
  {
    name: 'uikit.footer',
    path: '/dev/uikit/footer',
    component: () => import('@/pages/UiKit/FooterPage.vue'),
    meta: {
      dev: true
    }
  },
  {
    name: 'uikit.loaders',
    path: '/dev/uikit/loaders',
    component: () => import('@/pages/UiKit/LoadersPage.vue'),
    meta: {
      dev: true
    }
  },
  {
    name: 'uikit.sandbox',
    path: '/dev/uikit/sandbox',
    component: () => import('@/pages/UiKit/SandBox.vue'),
    meta: {
      dev: true
    }
  }
]
